"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotifications = exports.cleanNotification = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _request = _interopRequireDefault(require("@package/request"));

var _errors = require("@package/errors");

var _slice = require("./slice");

var cleanNotification = function cleanNotification() {
  return function (dispatch) {
    dispatch((0, _slice.resetStateAction)());
  };
};

exports.cleanNotification = cleanNotification;

var getNotifications = function getNotifications() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(dispatch) {
      var result;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch((0, _slice.getNotificationRequest)());
              _context.next = 4;
              return (0, _request["default"])({
                url: '/notifications',
                method: 'get',
                params: {
                  status: 'New',
                  take: '3',
                  skip: '0'
                }
              });

            case 4:
              result = _context.sent;
              dispatch((0, _slice.getNotificationRequestSuccess)(result));
              _context.next = 13;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);

              if (!(_context.t0 instanceof _errors.UnauthorizedError)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", void 0);

            case 12:
              dispatch((0, _slice.getNotificationRequestFail)(_context.t0));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getNotifications = getNotifications;